import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
//import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/general/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-afleveradressenedit',
  templateUrl: './afleveradressenedit.component.html',
  styleUrls: ['./afleveradressenedit.component.less']
})
export class AfleveradresseneditComponent implements OnInit {


  @Input() adres : any;
  @Output() deleted = new EventEmitter<number>();

  cols = 1;
  watcher: Subscription;
  activeMediaQuery = '';

  constructor(private relatiesService: RelatiesService,
              private toastr: ToastrService,
              private dialog: MatDialog,
              //private mediaObserver: MediaObserver
    ) { }

  ngOnInit() {
    // this.watcher = this.mediaObserver.media$.subscribe((change: MediaChange) => {
    //   this.activeMediaQuery = change ? `'${change.mqAlias}' = (${change.mediaQuery})` : '';
    //   if ( change.mqAlias == 'xs') {
    //      this.cols = 1;
    //   } else {
    //     this.cols = 2;
    //   }
    // });
  }


  delete() {
    const message = `Weet je zeker dat je dit wilt doen?`;

    const dialogData = new ConfirmDialogModel("Bevestig verwijdering", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      const result = dialogResult;
      if (result) {
          this.relatiesService.deleteAfleverAdres(this.adres.BedrijfNummer,this.adres.ID).subscribe(() => {
            this.toastr.error("", "Verwijderd");
            this.deleted.emit(this.adres.ID);
          }
          );
        }
      });
  }

  save() {
    this.relatiesService.saveAfleverAdres(this.adres).subscribe(() => {
      this.toastr.error("", "Opgeslagen");
    }
    );
  }

}
